import React, { useState } from "react";
import Modal from "./Modal";
import { runningAsApp, useInstallApp } from "../utils/installApp";

// "Install app" in the menu, always there: the browser's install prompt where it offers one; otherwise how to install
// it (Safari's Add to Home Screen on an iPhone, the browser menu elsewhere), or, once installed, how to open it.
export default function InstallApp({ className = "" }) {
  const { available, iosHelp, install } = useInstallApp();
  const [help, setHelp] = useState(null); // "ios" | "installed" | "browser"
  const open = () => {
    if (available && !iosHelp) install();
    else setHelp(iosHelp ? "ios" : runningAsApp() ? "installed" : "browser");
  };
  return (
    <>
      <button className={`admin-nav install-app-btn ${className}`} onClick={open}>
        <span className="nav-icon" aria-hidden="true">📲</span>Install app
      </button>
      {help === "ios" && (
        <Modal eyebrow="INSTALL APP" title="Add Ownezzy Admin to your home screen" onClose={() => setHelp(null)}>
          <ol className="install-help">
            <li>Tap the <b>Share</b> button at the bottom of Safari.</li>
            <li>Choose <b>Add to Home Screen</b>.</li>
            <li>Tap <b>Add</b>. The admin panel then opens from your home screen like an app.</li>
          </ol>
          <div className="product-modal-actions">
            <a href="/downloads/ownezzy.apk?v=2.0" download="ownezzy.apk" className="outline-btn" style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "6px" }}>
              <span>📱 Download Android APK (v2.0)</span>
            </a>
            <button className="primary-btn" onClick={() => setHelp(null)}>Got it</button>
          </div>
        </Modal>
      )}
      {help === "installed" && (
        <Modal eyebrow="INSTALL APP" title="The app is installed" onClose={() => setHelp(null)}>
          <p className="install-help-text">You are using the Ownezzy Admin app. Open it any time from your home screen or app list. To install it on another phone or computer, open the admin panel there and tap <b>Install app</b>.</p>
          <div className="product-modal-actions">
            <a href="/downloads/ownezzy.apk?v=2.0" download="ownezzy.apk" className="outline-btn" style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "6px" }}>
              <span>📱 Download Android APK (v2.0)</span>
            </a>
            <button className="primary-btn" onClick={() => setHelp(null)}>Got it</button>
          </div>
        </Modal>
      )}
      {help === "browser" && (
        <Modal eyebrow="INSTALL APP" title="Install Ownezzy Admin" onClose={() => setHelp(null)}>
          <ol className="install-help">
            <li>Open your browser's menu (<b>⋮</b> at the top right in Chrome or Edge).</li>
            <li>Choose <b>Install app</b> or <b>Add to Home screen</b>.</li>
            <li>If you don't see it, the app may already be installed: look for <b>Ownezzy Admin</b> on your home screen or app list.</li>
          </ol>
          <div className="product-modal-actions">
            <a href="/downloads/ownezzy.apk?v=2.0" download="ownezzy.apk" className="outline-btn" style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "6px" }}>
              <span>📱 Download Android APK (v2.0)</span>
            </a>
            <button className="primary-btn" onClick={() => setHelp(null)}>Got it</button>
          </div>
        </Modal>
      )}
    </>
  );
}
